window.addEventListener('load', function () {
    if (document.querySelectorAll('.productHeader').length) {
        const productHeader = document.querySelectorAll('.productHeader');

        productHeader.forEach(function (element) {
            mySwiper = new Swiper(element.querySelector('.swiper'), {
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true,
                checkInView: true,
                autoHeight: true,
                navigation: {
                    nextEl: element.querySelector('.swiper-button-next'),
                    prevEl: element.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });
        });

        function addLoupesToImgs() {
            let imagesInPage = jQuery('.productImage img');
            for (let imageIndex = 0; imageIndex <= imagesInPage.length; imageIndex++) {
                let imageToLoupe = imagesInPage[imageIndex];
                if (typeof imageToLoupe != "undefined") {
                    jQuery(imageToLoupe).addClass('imageToLoupe');
                    new Loupe(imageToLoupe);
                }
            }
        }

        function isMobile() {
            if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
                return true;
            } else {
                return false;
            }
        }

        if (isMobile() === false) {
            addLoupesToImgs();
        }
    }
});
